import { createFileRoute } from '@tanstack/react-router';
import { AccountSettingsLayout } from '@/features/account-settings';

export const Route = createFileRoute('/_authenticated/account-settings')({
    head: () => ({ meta: [{ title: 'Account Settings | promote.fun' }] }),
    component: AccountSettingsLayout,
});
